/**
 *
 * LockersFilter
 *
 */
import { LockersPicker } from 'app/components/pickers/AutocompletePickers/LockersPicker';
import * as React from 'react';
import { translations } from 'locales/translations';
import { useTranslation } from 'react-i18next';
import { Entity } from 'types/common';
import { IFilterComponentProps } from '../IFilterComponentProps';

export const LockersFilter = (props: IFilterComponentProps) => {
  const handleOnChange = (value: Entity<number> | null) => {
    props.onChange(value);
  };
  const { t } = useTranslation();
  return (
    <LockersPicker
      onChange={handleOnChange}
      value={props.value as Entity<number> | undefined}
      isOpen={props.open}
      placeholder={t(translations.AllValues)}
      ariaLabel={props.label}
      size="small"
      id={props.id}
    />
  );
};
export default LockersFilter;
